import axios from "axios";
import _ from "lodash";
import { API_BASE_URL, FIREBASE_CONFIG } from "../config";
import { initializeApp } from "@firebase/app";
import { getAuth, signInWithEmailAndPassword, updatePassword, updateEmail, sendPasswordResetEmail } from "firebase/auth";

var firebaseConfig = FIREBASE_CONFIG;

initializeApp(firebaseConfig);

let auth = {};

auth.login = (email, password) => {
    const fauth = getAuth();

    return new Promise((resolve, reject) => {
        signInWithEmailAndPassword(fauth, email, password).then((user) => {
            if (user) {

                fauth.currentUser.getIdToken().then((token) => {
                    axios({
                        url: `${API_BASE_URL}/insurance-staff/login`,
                        method: "POST",
                        data: { authToken: token, email, password }
                    }).then((data) => {
                        if (_.get(data, "data.success", false)) {
                            let token = _.get(data, "data.data.token", "")
                            localStorage.setItem('token-insurance-staff', token);
                            resolve({ status: true, message: "Login successfully." });
                            return;
                        } else {
                            let message = _.get(data, "data.message", "Incorrect email or password.")
                            fauth.signOut()
                            reject({ status: false, message: message })
                            return;
                        }

                    }).catch((e) => {
                        reject({ status: false, message: "Incorrect email or password." })
                        fauth.signOut();
                    })

                })
            } else {
                resolve({ status: false, message: "Incorrect Email or Password." });
            }
        }).catch(err => {
            resolve({ status: false, message: "Incorrect Email or Password." });
        });
    });

}

auth.logout = async () => {
    return new Promise((resolve) => {
        const fauth = getAuth();
        fauth.signOut().then(() => {
            resolve(true);
        }).catch(err => {
            resolve(true)
        });
    })
}

auth.profile = async () => {
    const url = `${API_BASE_URL}/insurance-staff/profile`;
    const res = await axios({ url });
    return res;
}
auth.dashboardCount = async () => {
    const url = `${API_BASE_URL}/insurance-staff/dashboard-count`;
    const res = await axios({ url });
    return res;
}

auth.changePasswordApi  = async (data) => {
    const url = `${API_BASE_URL}/insurance-staff/update-password`;
    const res = await axios({ url, method: "PUT", data });
    return res;
}

auth.updateEmailApi = async (data) => {
    const url = `${API_BASE_URL}/insurance-staff/update-email`;
    const res = await axios({ url, method: "PUT", data });
    return res;
}

auth.updateLogoApi = async(data) => {
    const url = `${API_BASE_URL}/insurance-staff/update-logo`;
    const res = await axios({url, method: "PUT", data})
    return res
}

auth.user = false;

auth.getProfile = (hard = false) => {
    return new Promise(async (res, rej) => {

        const fauth = getAuth();

        await fauth.onAuthStateChanged((user) => {
            if (!user || !localStorage.getItem("token-insurance-staff")) {
                localStorage.removeItem("token-insurance-staff");
                hard = true;
            }

            if (auth.user && !hard) {
                res(auth.user);
            } else if (localStorage.getItem("token-insurance-staff") || hard) {
                let userCall = auth.profile();
                userCall.then(
                    (e) => {
                        if (_.get(e, "data.success", false)) {
                            auth.user = _.get(e, "data.data");
                            res(auth.user);
                        } else {
                            auth.user = false;
                            res(false);
                        }
                    }, (er) => {
                        auth.user = false;
                        res(false);
                    }
                );
            } else {
                res(false);
            }
        });

    });
}

auth.updatePassword = async (oldPassword, newPassword) => {
    const firebaseAuth = getAuth();
    return new Promise((resolve, reject) => {
        signInWithEmailAndPassword(firebaseAuth, firebaseAuth.currentUser.email, oldPassword).then((user) => {

            updatePassword(firebaseAuth.currentUser, newPassword).then(() => {
                resolve({ status: true, message: "Password updated successfully." });
            }).catch((error) => {
                console.log("error", error, error.toString());
                resolve({ status: false, message: "Something went wrong." });
            });

        }).catch(err => {
            resolve({ status: false, message: "Incorrect Password." });
        });

    })
}

auth.updateEmail = async (email, password) => {
    const firebaseAuth = getAuth();
    return new Promise((resolve, reject) => {
        signInWithEmailAndPassword(firebaseAuth, firebaseAuth.currentUser.email, password).then((user) => {
            updateEmail(firebaseAuth.currentUser, email).then(async () => {
                try {
                    await auth.updateEmailApi();
                    resolve({ status: true, message: "Email updated successfully." });
                } catch (error) {
                    resolve({ status: false, message: "Something went wrong." });
                }

            }).catch((error) => {
                console.log("error", error, error.toString());
                resolve({ status: false, message: "Something went wrong." });
            });

        }).catch(err => {
            resolve({ status: false, message: "Incorrect Password." });
        });

    })
}

auth.getEmail = () => {
    const firebaseAuth = getAuth();
    return firebaseAuth.currentUser.email;
}

auth.sendResetMail = async (mail) => {
    return new Promise(async (resolve, reject) => {

        // Check is insurance
        try {
            let response = await auth.sendForgotMail({email: mail});

            // Send mail
            if(response && _.get(response, "data.success") === true){
                resolve({ status: true, message: "Mail sent successfully." });
            }else{
                resolve({ status: false, message: _.get(response, "data.message", "Invalid email.") });
            }
            
        } catch (error) {
            resolve({ status: false, message: "Something went wrong." });
            return ;
        }
    });
}

auth.checkResetPasswordCode = async (code) => {
    return new Promise(async (resolve, reject) => {

        // Check is reinsurance
        try {
            let response = await auth.checkRestPasswordCodeAPI({code: code});

            // Send mail
            if(response && _.get(response, "data.success") === true){
                resolve({ status: true });
            }else{
                resolve({ status: false, message: _.get(response, "data.message", "Invalid Link.") });
            }
            
        } catch (error) {
            resolve({ status: false, message: "Something went wrong." });
            return ;
        }
    });
}

auth.ResetPassword = async (data) => {
    return new Promise(async (resolve, reject) => {

        // Check is insurance-staff
        try {
            const url = `${API_BASE_URL}/insurance-staff/reset-password`;
            const response = await axios({ url, method: "POST", data });
            // Send mail
            if(response && _.get(response, "data.success") === true){
                resolve({ status: true, message: "Password reset successfully." });
            }else{
                resolve({ status: false, message: _.get(response, "data.message", "Something went wrong.") });
            }
            
        } catch (error) {
            resolve({ status: false, message: "Something went wrong." });
            return ;
        }
    });
}

auth.sendForgotMail  = async (data) => {
    const url = `${API_BASE_URL}/insurance-staff/send-forgot-password-mail`;
    const res = await axios({ url, method: "POST", data });
    return res;
}

auth.checkRestPasswordCodeAPI  = async (data) => {
    const url = `${API_BASE_URL}/insurance-staff/check-reset-password-code`;
    const res = await axios({ url, method: "POST", data });
    return res;
}

auth.getHeader = () => {
    const token = localStorage.getItem("token-insurance-staff");
    return {
        "Authorization": token
    }
}

export default auth;